import * as regexp from './regexp'

// 校验年份合法性
export let year = v => {
  return regexp.year().test(v) && v >= 1900
}

// 校验日期合法性
export let date = v => {
  let match = regexp.date().exec(v)
  if (!match) return false
  let year = match[1]
  let month = match[2]
  let day = match[3]
  if (year < 1900) return false
  if (month > 12 || month <= 0) return false
  if (day > 31 || day <= 0) return false
  let date = new Date(year, month - 1, day)
  return date && date.getMonth() === month - 1
}

// 校验身份证号合法性
export let id_number = v => {
  let match = regexp.id_number().exec(v)
  if (!match) return false
  if (!date(match[2])) return false
  let weight = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
  let inverse = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2]
  let sum = 0
  for (let i = 0, len = weight.length; i < len; i++) sum += weight[i] * v[i]
  let remainder = sum % 11
  return v[v.length - 1].toUpperCase() === inverse[remainder] + ''
}



// WEBPACK FOOTER //
// ./src/utils/validator.js